/** The four operations a child can practise. */
export const OPS = ["add", "sub", "mul", "div"] as const;
export type Op = (typeof OPS)[number];

/** A mode is an operation, or "mix" which draws from every enabled operation. */
export const MODES = ["add", "sub", "mul", "div", "mix"] as const;
export type Mode = (typeof MODES)[number];

/** colour: the strand's colour, for set dots and the Elemental aura. */
export const MODE_INFO: Record<Mode, { sym: string; label: string; colour: string }> = {
  add: { sym: "+", label: "Add", colour: "#E4572E" },
  sub: { sym: "−", label: "Take", colour: "#3E7CB1" },
  mul: { sym: "×", label: "Times", colour: "#2F8F5B" },
  div: { sym: "÷", label: "Share", colour: "#8E5BD0" },
  mix: { sym: "✦", label: "Mix", colour: "#E0A10B" },
};

export function isMode(value: unknown): value is Mode {
  return typeof value === "string" && (MODES as readonly string[]).includes(value);
}
